<template>
  <v-list v-if="muestraMenuArmeria">
    <v-list-item>
      <v-menu bottom left offset-x>
        <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
          <v-tooltip right>
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <IconButton
                icon="mdi-book"
                class="mr-3"
                v-bind="mergeAttrs(menuAttrs, tooltipAttrs)"
                v-on="mergeOn(menuOn, tooltipOn)"
              />
            </template>
            <span>Registros LOC</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item link to="/armeria/loc_personal">
            <v-list-item-title>Registro de personal a LOC</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton icon="mdi-pistol" class="mr-3" v-bind="attrs" v-on="on" to="/armeria/inventario_de_armas" />
        </template>
        <span> Inventario de armas </span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton
            icon="mdi-license"
            class="mr-3"
            to="/armeria/licencia_oficial_colectiva"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Licencia Oficial Colectiva</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton
            icon="mdi-shield-account"
            class="mr-3"
            to="/armeria/personal_armamento"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Personal con armamento</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton
            icon="mdi-account-group"
            class="mr-3"
            to="/armeria/personal_activo"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Personal activo</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton
            icon="mdi-shield-alert"
            class="mr-3"
            to="/armeria/intervencion_activa"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Intervención temprana</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <IconButton icon="mdi-account-tie" class="mr-3" to="/armeria/asignacion_arma" v-bind="attrs" v-on="on" />
        </template>
        <span>Asignar arma a personal</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item>
      <v-menu bottom left offset-x>
        <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
          <v-tooltip right>
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <IconButton
                icon="mdi-ammunition"
                class="mr-3"
                v-bind="mergeAttrs(menuAttrs, tooltipAttrs)"
                v-on="mergeOn(menuOn, tooltipOn)"
              />
            </template>
            <span>Asignaciones</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item link to="/armeria/asignacion_municion">
            <v-list-item-title>Asignar municiones a personal</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list>
          <v-list-item link to="/armeria/registro_cargador">
            <v-list-item-title>Registro de cargador</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list>
          <v-list-item link to="/armeria/asignacion_municion_curso">
            <v-list-item-title>Asignar municiones a un curso</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
    <v-list-item>
      <v-menu bottom left offset-x>
        <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
          <v-tooltip right>
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <IconButton
                icon="mdi-package"
                class="mr-3"
                v-bind="mergeAttrs(menuAttrs, tooltipAttrs)"
                v-on="mergeOn(menuOn, tooltipOn)"
              />
            </template>
            <span>Inventarios</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item link to="/armeria/inventario_municiones">
            <v-list-item-title>Inventario de municiones y cargadores</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/armeria/inventario_items" v-if="hasAccessToFeature(perfil, FEATURES.INVENTARIO_ITEMS)">
            <v-list-item-title>Inventario de items</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            to="/armeria/asignacion_items"
            v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_ITEMS_PERSONAL)"
          >
            <v-list-item-title>Asignación de items a personal</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'

export default {
  components: {
    IconButton,
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    muestraMenuArmeria() {
      return this.$route.matched.some(({ path }) => path === '/armeria')
    },
  },

  methods: {
    mergeAttrs(...sources) {
      return Object.assign({}, ...sources)
    },

    mergeOn(...sources) {
      return Object.assign({}, ...sources)
    },
  },
}
</script>
